import {
  Box,
  Button,
  Collapse,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import {
  AddIcCallOutlined,
  Delete,
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import InputMask from "react-input-mask";
import dayjs from "dayjs";
import { LocalizationProvider, TimeField } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { removeMask } from "../../../../../../utils/masks";

// Bloco "Contatos de escalonamento" — renderizado dentro da seção Parceiro Última
// Milha (ver ParceiroUltimaMilhaSection). Puramente apresentacional (sem estado
// próprio) — extraído de circuito/index.js (etapa 19, passo 3, do plano de
// melhorias), mesmo JSX/comportamento, só movido de arquivo. Os dois blocos de
// campos (primeiro contato / contatos adicionais) permanecem duplicados de
// propósito, exatamente como estavam — deduplicá-los é uma melhoria à parte, fora
// do escopo desta extração.
export default function EscalationContactsSection({
  styles,
  formData,
  editMode,
  loading,
  showAllContacts,
  setShowAllContacts,
  handleAddContatoEscalacao,
  handleContatoEscalacaoChange,
  handleRemoveContatoEscalacao,
}) {
  return (
    <>
      <Grid item xs={12}>
        <Box sx={styles.boxRow}>
          <Box sx={styles.titleWithConfig}>
            <AddIcCallOutlined color="primary" />
            <Typography variant="subtitle2">
              Contatos de escalonamento:
            </Typography>
          </Box>
          <Button
            variant="outlined"
            size="small"
            onClick={handleAddContatoEscalacao}
            color="primary"
            startIcon={<AddIcon />}
            disabled={!editMode || loading}
          >
            Adicionar
          </Button>
        </Box>
      </Grid>
      <Grid container spacing={1} sx={styles.contentIdentation}>
        {formData?.lastMilePartner?.escalationContacts
          ?.slice(0, 1)
          ?.map((contato, index) => (
            <Grid item xs={12} key={index}>
              <Box
                sx={{ ...styles.boxRow, ...(index > 0 && { mt: 1 }) }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      sx={styles.textField}
                      disabled={!editMode || loading}
                      autoComplete="off"
                      fullWidth
                      size="small"
                      label={`Nome do contato ${index + 1}`}
                      value={contato?.name || ""}
                      onChange={(e) =>
                        handleContatoEscalacaoChange(
                          index,
                          "name",
                          e.target.value,
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      sx={styles.textField}
                      disabled={!editMode || loading}
                      autoComplete="off"
                      fullWidth
                      size="small"
                      label="Cargo"
                      value={contato?.role || ""}
                      onChange={(e) =>
                        handleContatoEscalacaoChange(
                          index,
                          "role",
                          e.target.value,
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <InputMask
                      mask={
                        removeMask(contato?.phone || "")?.length <= 10
                          ? "(99) 9999-99999"
                          : "(99) 99999-9999"
                      }
                      value={contato?.phone || ""}
                      onChange={(e) =>
                        handleContatoEscalacaoChange(
                          index,
                          "phone",
                          removeMask(e?.target?.value),
                        )
                      }
                      maskChar=""
                      disabled={!editMode || loading}
                    >
                      {(props) => (
                        <TextField
                          sx={styles.textField}
                          disabled={!editMode || loading}
                          autoComplete="off"
                          {...props}
                          fullWidth
                          size="small"
                          label="Telefone"
                        />
                      )}
                    </InputMask>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimeField
                        sx={styles.textField}
                        disabled={!editMode || loading}
                        label="Tempo de escalonamento (HH:mm)"
                        format="HH:mm"
                        fullWidth
                        size="small"
                        value={
                          contato?.escalationTime !== undefined &&
                          contato.escalationTime !== null
                            ? dayjs()
                                ?.startOf("day")
                                ?.add(contato?.escalationTime, "minute")
                            : null
                        }
                        onChange={(newValue) => {
                          // Converte o valor selecionado de volta para minutos
                          const minutes = newValue
                            ? newValue?.hour() * 60 + newValue?.minute()
                            : 0;

                          handleContatoEscalacaoChange(
                            index,
                            "escalationTime",
                            minutes,
                          );
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
                {!!editMode && (
                  <IconButton
                    size="small"
                    onClick={() => {
                      handleRemoveContatoEscalacao(index);
                    }}
                    disabled={!editMode || loading}
                    color="error"
                  >
                    <Delete />
                  </IconButton>
                )}
              </Box>
            </Grid>
          ))}

        {/* Contatos adicionais dentro do Collapse */}
        {formData?.lastMilePartner?.escalationContacts?.length > 1 && (
          <Grid item xs={12} sx={{ ...(showAllContacts && { mt: 1 }) }}>
            <Collapse in={showAllContacts} timeout="auto" unmountOnExit>
              <Grid container spacing={2}>
                {formData?.lastMilePartner?.escalationContacts
                  ?.slice(1)
                  ?.map((contato, index) => (
                    <Grid item xs={12} key={index + 1}>
                      <Box sx={styles.boxRow}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} sm={6} md={3}>
                            <TextField
                              sx={styles.textField}
                              disabled={!editMode || loading}
                              autoComplete="off"
                              fullWidth
                              size="small"
                              label={`Nome do contato ${index + 2}`}
                              value={contato?.name || ""}
                              onChange={(e) =>
                                handleContatoEscalacaoChange(
                                  index + 1,
                                  "name",
                                  e.target.value,
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <TextField
                              sx={styles.textField}
                              disabled={!editMode || loading}
                              autoComplete="off"
                              fullWidth
                              size="small"
                              label="Cargo"
                              value={contato?.role || ""}
                              onChange={(e) =>
                                handleContatoEscalacaoChange(
                                  index + 1,
                                  "role",
                                  e.target.value,
                                )
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <InputMask
                              mask={
                                removeMask(contato?.phone || "")
                                  ?.length <= 10
                                  ? "(99) 9999-99999"
                                  : "(99) 99999-9999"
                              }
                              value={contato?.phone || ""}
                              onChange={(e) =>
                                handleContatoEscalacaoChange(
                                  index + 1,
                                  "phone",
                                  removeMask(e?.target?.value),
                                )
                              }
                              maskChar=""
                              disabled={!editMode || loading}
                            >
                              {(props) => (
                                <TextField
                                  sx={styles.textField}
                                  disabled={!editMode || loading}
                                  autoComplete="off"
                                  {...props}
                                  fullWidth
                                  size="small"
                                  label="Telefone"
                                />
                              )}
                            </InputMask>
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                            >
                              <TimeField
                                sx={styles.textField}
                                disabled={!editMode || loading}
                                label="Tempo de escalonamento (HH:mm)"
                                format="HH:mm"
                                fullWidth
                                size="small"
                                value={
                                  contato?.escalationTime !==
                                    undefined &&
                                  contato.escalationTime !== null
                                    ? dayjs()
                                        ?.startOf("day")
                                        ?.add(
                                          contato?.escalationTime,
                                          "minute",
                                        )
                                    : null
                                }
                                onChange={(newValue) => {
                                  const minutes = newValue
                                    ? newValue?.hour() * 60 +
                                      newValue?.minute()
                                    : 0;
                                  handleContatoEscalacaoChange(
                                    index + 1,
                                    "escalationTime",
                                    minutes,
                                  );
                                }}
                              />
                            </LocalizationProvider>
                          </Grid>
                        </Grid>
                        {!!editMode && (
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleRemoveContatoEscalacao(index + 1)
                            }
                            disabled={!editMode || loading}
                            color="error"
                          >
                            <Delete />
                          </IconButton>
                        )}
                      </Box>
                    </Grid>
                  ))}
              </Grid>
            </Collapse>
          </Grid>
        )}

        {/* Botão Expandir / Recolher */}
        {formData?.lastMilePartner?.escalationContacts?.length > 1 && (
          <Grid
            item
            xs={12}
            sx={{ ...(!showAllContacts && { mt: -1 }) }}
          >
            <Button
              size="small"
              onClick={() => setShowAllContacts(!showAllContacts)}
              startIcon={
                showAllContacts ? <ExpandLess /> : <ExpandMore />
              }
            >
              {showAllContacts
                ? "Recolher contatos"
                : "Ver todos os contatos"}
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  );
}
